module.exports = __webpack_public_path__ + "static/media/never.45f9c403.svg";